module.exports = __webpack_public_path__ + "static/media/logo-comprasnet.bbd2ad9e.png";